import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@web-chat-core/ui-kit';
import { selectIsUserSpeakWhileMuted } from 'features/MutedSpeechDetection/state/selectors/selectors';
import { useTooltipObstructionGuard } from 'features/MutedSpeechDetection/hooks/useTooltipObstructionGuard';
import { observer } from 'mobx-react-lite';

interface MutedSpeechTooltipProps {
    children: ReactElement;
}

export const MutedSpeechTooltip = observer(({ children }: MutedSpeechTooltipProps) => {
    const { t } = useTranslation();

    const isUserSpeakWhileMuted = selectIsUserSpeakWhileMuted();

    const bubbleRef = useTooltipObstructionGuard();

    return (
        <Tooltip
            contentRef={bubbleRef}
            manuallyOpened={isUserSpeakWhileMuted}
            variant="info"
            label={t('vks_microphone_off_hint')}
            disableHoverableContent={true}
            textAlign="left"
        >
            {children}
        </Tooltip>
    );
});

MutedSpeechTooltip.displayName = 'MutedSpeechTooltip';
